export default __webpack_public_path__ + "static/media/draftComments.80c55c73.png";